import { Component, OnDestroy } from "@angular/core";
import { ControlValueAccessor, FormBuilder, FormGroup } from "@angular/forms";
import { AlertController, NavController, NavParams } from "ionic-angular";
import { Subscription } from "rxjs";
import { CompanyDetails } from "../company-details";

@Component({
  selector: "workgroup-add-member",
  templateUrl: "workgroup-add-member.html",
})
export class WorkgroupAddMember
  extends CompanyDetails
  implements ControlValueAccessor, OnDestroy
{
  activityLogForm: FormGroup;
  subscriptions: Subscription[] = [];
  selectedMembers = [
    {
      name: "Alana Dustin",
      email: "adustin@care.com",
    },
    {
      name: "Erica Frost",
      email: "efrost@care.com",
    },
    {
      name: "Robert North",
      email: "rnorth@care.com",
    },
  ];
  title: string;

  constructor(
    protected formBuilder: FormBuilder,
    public navCtrl: NavController,
    private navParams: NavParams,
    private alertController: AlertController
  ) {
    super(formBuilder);
    this.title = this.navParams.get("title") || "Add Members";
    this.innerFormGroup = this.formBuilder.group({
      members: [[]],
    });

    this.subscriptions.push(
      this.innerFormGroup.valueChanges.subscribe((value) => {
        this.onChange(value);
        this.onTouched();
      })
    );
  }

  addMember(member) {
    this.selectedMembers =
      this.selectedMembers === null ? [] : this.selectedMembers;
    if (this.selectedMembers.includes(member)) {
      const index = this.selectedMembers.indexOf(member);
      this.selectedMembers.splice(index, 1);
    } else {
      this.selectedMembers.push(member);
    }
    this.innerFormGroup.get("members").setValue(this.selectedMembers);
  }

  removeMember(member) {
    if (this.selectedMembers.includes(member)) {
      // console.log(this.selectedMembers.indexOf(member))
      this.selectedMembers.splice(this.selectedMembers.indexOf(member), 1);
      this.innerFormGroup.get("members").setValue(this.selectedMembers);
      // console.log(this.innerFormGroup.get('members').value);
    }
  }

  submit() {
    let alert = this.alertController.create({
      title: "Submit Confirmation",
      message: "Are you sure you wish to add these members?",
      buttons: [
        {
          text: "No",
          handler: () => {},
        },
        {
          text: "Yes",
          handler: () => {
            //Service call to add member
          },
        },
      ],
    });
    alert.present();
  }

  cancel() {
    let alert = this.alertController.create({
      title: "Cancel Confirmation",
      message: "Are you sure you wish to cancel?",
      buttons: [
        {
          text: "No",
          handler: () => {},
        },
        {
          text: "Yes",
          handler: () => {
            this.navCtrl.pop();
          },
        },
      ],
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/company/company-details/add-member/workgroup-add-member.ts